import { Autocomplete, TextField } from "@mui/material";

export default function VenueSelect({ venueOption, venueId, setVenueId }) {
  console.log(venueOption, "OPTS");
  return (
    <Autocomplete
      options={venueOption}
      value={venueOption.find((v) => v.id + "" === venueId + "") || null}
      onChange={(_, newValue) => setVenueId(newValue ? newValue.id + "" : "")}
      isOptionEqualToValue={(option, value) => option.id === value.id}
      sx={{ width: "100%" }}
      getOptionLabel={(option) => {
        if (!option) return "NA";

        const hasDeckNumber = option?.data?.some((d) => d.deck_number);
        const details = hasDeckNumber
          ? option?.data
              ?.map((d) => `Deck ${d.deck_number} – ${d.location || "NA"}`)
              .join(", ")
          : "NA";

        return `${option?.name} | ${details}`;
      }}
      renderInput={(params) => (
        <TextField {...params} placeholder="Search venue..." size="small" />
      )}
      renderOption={(props, option) => {
        const hasDeckNumber = option?.data?.some((d) => d.deck_number);

        const deckHtml = hasDeckNumber
          ? option?.data
              ?.map(
                (d) =>
                  `<span style="color:#555;">Deck ${d.deck_number}</span> – ${
                    d.location || "NA"
                  } - <i style='color:#888;'>${d.side || "NA"}</i>`
              )
              .join("<br/>")
          : "<i style='color:#888;'>NA</i>";

        return (
          <li {...props}>
            <div
              dangerouslySetInnerHTML={{
                __html: `
                  <strong style="font-size:14px;">${option?.name}</strong><br/>
                  ${deckHtml}
                `,
              }}
            />
          </li>
        );
      }}
    />
  );
}
